export const getOrganisationPrettyName = () => {
    let organisationPrettyName = '';
    const origin = window.location.hostname;
    if (origin.indexOf('.') > 0) {
        organisationPrettyName = origin.substring(0, origin.indexOf('.'));
    }
    return organisationPrettyName;
};
